import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import rootReducers from './reducers';

const initialState = {};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for redux dev tools
const store = createStore(rootReducers, initialState, composeEnhancers(applyMiddleware(thunk)));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).store = store;
export default store;
